module.exports = __webpack_public_path__ + "img/Flag_of_Kyrgyzstan.c08e9251.svg";